import { useCopilotMessagesContext, useCopilotReadable, useFrontendTool, useThreads } from "@copilotkit/react-core";
import { useAgent } from "@copilotkit/react-core/v2";
import { CopilotPopup, useChatContext } from "@copilotkit/react-ui";
import { useStore } from "@priolo/jon";
import RootIcon from "images/menu/root2";
import { FunctionComponent } from "react";
import copilotKitSo from "stores/copilotkit";
import { useContext } from "stores/copilotkit/useContext";
import { useNavigate } from "stores/copilotkit/useNavigate";
import { useSystemContext } from "stores/copilotkit/useSystemContext";
import locationSo from "stores/route/location";
import "./PopUp.css";
import { useGetPLCValues } from "stores/copilotkit/useGetPLCValues";
import { useSetValues } from "stores/copilotkit/useSetValues";
import { usePivotgrid } from "stores/copilotkit/usePivotgrid";
import { usePlanner } from "stores/copilotkit/usePlanner";
import { useGetValues } from "stores/copilotkit/useGetValues";

const popupAgent = import.meta.env.VITE_COPILOTKIT_POPUP_AGENT ?? "chatbot_agent"



interface Props {
}

/**
 * 
 */
const PopUp: FunctionComponent<Props> = ({
}) => {

	// STORE
	useStore(copilotKitSo)
	useStore(locationSo)


	// COPILOTKIT HOOK
	// const { agent } = useAgent({ agentId: popupAgent })
	// copilotKitSo.state.agent = agent

	useSystemContext()
	useContext()
	useNavigate()
	useGetValues()
	useGetPLCValues()
	useSetValues()
	usePivotgrid()
	usePlanner()

	return <>
		{/* {copilotKitSo.state.descriptions.map((description, idx) => (
			<SingleDescription key={idx} description={description} />
		))}

		{copilotKitSo.state.actions.map((action, idx) => (
			<SingleAction key={idx} action={action} />
		))} */}

		<div className="copilot-popup-dark">
			<CopilotPopup
				icons={{
					openIcon: <RootIcon />
				}}
				labels={{
					title: "Your Assistant",
					initial: "Hi! 👋 How can I assist you today?",
				}}
				Header={NewChatHeader}
			/>
		</div>
	</>
}

export default PopUp;


// function SingleAction({ action }) {
// 	useFrontendTool(action);
// 	return null;
// }

// function SingleDescription({ description }) {
// 	useCopilotReadable(description);
// 	return null;
// }

function NewChatHeader() {
	const { setOpen, icons, labels } = useChatContext();
	const { setMessages } = useCopilotMessagesContext();
	const { setThreadId } = useThreads();

	const handleNewChat = () => {
		setMessages([]);
		setThreadId(crypto.randomUUID());
	};

	return (
		<div className="copilotKitHeader">
			<div>{labels.title}</div>
			<div className="copilotKitHeaderControls">
				<button
					onClick={handleNewChat}
					aria-label="New chat"
					className="copilotKitHeaderNewButton"
				>
					New
				</button>
				<button
					onClick={() => setOpen(false)}
					aria-label="Close"
					className="copilotKitHeaderCloseButton"
				>
					{icons.headerCloseIcon}
				</button>
			</div>
		</div>
	);
}